import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

/**
 * Whether the viewer has asked for reduced motion.
 *
 * Decorative animation is skipped entirely rather than merely shortened —
 * for someone who gets motion sickness, a fast animation is still an animation.
 */
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(
    () => typeof matchMedia === "function" && matchMedia(QUERY).matches
  );

  useEffect(() => {
    if (typeof matchMedia !== "function") return;

    const query = matchMedia(QUERY);
    const onChange = () => setReduced(query.matches);

    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, []);

  return reduced;
}
